import React, { useState } from 'react'
import { Button, Card, Col, Image, Spinner } from 'react-bootstrap'
import { BsFillFileEarmarkPdfFill, BsXLg } from 'react-icons/bs'
import {
  createFilesDocsAPI,
  getFilesDocsAPI,
  updateFilesDocsAPI
} from '../../../services/files'
import Error_false from '../../error/error-false'
import { useDropzone } from 'react-dropzone'
import SwalCustom from '../../../alert/swal-custom'
import IconDownload from '../../../images/Action/Download.svg'
import IconView from '../../../images/Action/pdf.svg'
import Swal from 'sweetalert2'
import updateProfilePercent from '../../../helper/updateProfile-percent'
import { useDispatch } from 'react-redux'
function FileDocsTable({
  idcode,
  fnData,
  detail,
  roles,
  isFile,
  keys,
  typeId,
  insertDate,
  mandatory
}) {
  const [isSave, setIsSave] = useState(false)
  const [filedocs, setFileDocs] = useState([])
  const dispatch = useDispatch()
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    maxSize: 8000000,
    accept: {
      'pdf/pdf': ['.pdf']
    },
    onDrop: (acceptedFiles) => {
      setFileDocs(acceptedFiles.map((file) => Object.assign(file)))
    },
    onDropRejected: () => {
      Swal.fire({
        icon: 'error',
        title: 'You can only upload 1 file & maximum size of 8 MB.',
        showConfirmButton: false,
        timer: 3000
      })
    }
  })

  const createFilesDocs = async () => {
    setIsSave(true)
    var c_formData = new FormData()
    c_formData.append('file', filedocs[0])
    c_formData.append('orgId', idcode.orgId)
    c_formData.append('code', idcode.code)
    c_formData.append('typeId', typeId)
    const data = await createFilesDocsAPI(c_formData)
    if (data?.status) {
      SwalCustom({
        title: 'Success!',
        text: 'Your Document has been attached.',
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        setFileDocs([])
        fnData()
        updateProfilePercent(dispatch)
      })
    } else {
      Error_false(data)
    }
    setIsSave(false)
  }

  const updataFilesDocs = async () => {
    setIsSave(true)
    var u_formData = new FormData()
    u_formData.append('file', filedocs[0])
    const param = {
      ...idcode,
      typeId: typeId
    }
    const data = await updateFilesDocsAPI(param, u_formData)
    if (data.status) {
      SwalCustom({
        title: 'Success!',
        text: 'Your Document has been attached.',
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        setFileDocs([])
        fnData()
      })
    } else {
      Error_false(data)
    }
    setIsSave(false)
  }

  const getFilesDocs = async () => {
    const body = {
      ...idcode,
      typeId
    }
    const { result } = await getFilesDocsAPI(body)
    if (!result) return
    void window.open(result[0]?.url, '_blank')
  }
  const renderFilePreview = (file) => {
    if (file.type.startsWith('image')) {
      return (
        <img
          width={38}
          height={38}
          alt={file.name}
          src={URL.createObjectURL(file)}
        />
      )
    } else {
      return (
        <BsFillFileEarmarkPdfFill
          className="opacity-25"
          style={{
            fontSize: '2rem'
          }}
        />
      )
    }
  }
  const fileList = filedocs.map((file) => (
    <span
      key={file.name}
      className="d-flex justify-content-between align-items-start"
    >
      <div className="d-flex align-items-center">
        <div>{renderFilePreview(file)}</div>
        <div className="my-auto ms-3">
          <p className="mb-0">{file.name}</p>
          <div className="font-small-2 fw-lighter text-start">
            {' '}
            {Math.round(file.size / 100) / 10 > 1000
              ? `${(Math.round(file.size / 100) / 10000).toFixed(1)} mb`
              : `${(Math.round(file.size / 100) / 10).toFixed(1)} kb`}
          </div>
        </div>
      </div>
      <div onClick={() => handleRemoveFile(file)}>
        <BsXLg fontSize={20} />
      </div>
    </span>
  ))
  const handleRemoveAllFiles = () => {
    setFileDocs([])
  }
  const handleRemoveFile = (file) => {
    const uploadedFiles = filedocs
    const filtered = uploadedFiles.filter((i) => i.name !== file.name)
    setFileDocs([...filtered])
  }
  const htmlUploadFile = (
    <div {...getRootProps()}>
      <input {...getInputProps()} />

      <Image
        style={{
          width: '16px'
        }}
        className="pointer-event"
        src={IconDownload}
      ></Image>
    </div>
  )
  return (
    <tr key={keys} className="fw-light font-small-2 ">
      <td className="text-center">{keys + 1}</td>
      <td>
        {detail}{' '}
        {mandatory === 1 ? (
          <span className="text-danger">(*)</span>
        ) : (
          <span className="text-warning">(ถ้ามี)</span>
        )}
      </td>

      <td>
        <div className="text-center">{insertDate}</div>
      </td>
      <td className="text-center">
        <div>
          {isFile ? (
            <Col xl={12} md={12}>
              {filedocs.length ? (
                <div className="mt-3" style={{ width: '100%' }}>
                  <Card className="p-2">{fileList}</Card>
                  {filedocs.length > 1 ? (
                    <span className="text-danger small">
                      สามารถอัปโหลดไฟล์ได้เพียง 1 ไฟล์เท่านั้น*
                    </span>
                  ) : (
                    <></>
                  )}
                  <div className="mt-2">
                    <Button
                      variant="outline-danger"
                      disabled={isSave}
                      onClick={handleRemoveAllFiles}
                    >
                      นำออก
                    </Button>
                    <Button
                      disabled={isSave}
                      className="ms-3"
                      onClick={updataFilesDocs}
                    >
                      {isSave ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          className="me-2"
                          aria-hidden="true"
                        />
                      ) : (
                        <BsFillFileEarmarkPdfFill className="me-2" />
                      )}
                      {isSave ? 'กำลังบันทึกไฟล์...' : 'บันทึกไฟล์'}
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="d-flex justify-content-center gap-3">
                  <Image
                    className="pointer-event"
                    onClick={getFilesDocs}
                    style={{ width: '18px' }}
                    src={IconView}
                  />
                  {htmlUploadFile}
                </div>
              )}
            </Col>
          ) : (
            <Col xl={12} md={12}>
              <>
                {htmlUploadFile}
                {filedocs.length ? (
                  <div className="mt-3" style={{ width: '100%' }}>
                    <Card className="p-2">{fileList}</Card>
                    {filedocs.length > 1 ? (
                      <span className="text-danger small">
                        สามารถอัปโหลดไฟล์ได้เพียง 1 ไฟล์เท่านั้น*
                      </span>
                    ) : (
                      <></>
                    )}
                    <div className="mt-2">
                      <Button
                        variant="outline-danger"
                        disabled={isSave}
                        onClick={handleRemoveAllFiles}
                      >
                        นำออก
                      </Button>
                      <Button
                        disabled={isSave}
                        className="ms-3"
                        onClick={createFilesDocs}
                      >
                        {isSave ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            className="me-2"
                            aria-hidden="true"
                          />
                        ) : (
                          <BsFillFileEarmarkPdfFill className="me-2" />
                        )}
                        {isSave ? 'กำลังบันทึกไฟล์...' : 'บันทึกไฟล์'}
                      </Button>
                    </div>
                  </div>
                ) : null}
              </>
            </Col>
          )}
        </div>
      </td>
    </tr>
  )
}

export default FileDocsTable
